import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["to"];
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { margin } from 'styled-system';
import { getOmittableProps } from '../helpers/omit';
var LinkBase = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var to = props.to,
      rest = _objectWithoutProperties(props, _excluded);

  return /*#__PURE__*/React.createElement("a", Object.assign({
    ref: ref,
    href: to
  }, rest));
});
var styleProps = getOmittableProps(margin, 'variant');
export var Link = /*#__PURE__*/styled(LinkBase).withConfig({
  shouldForwardProp: function shouldForwardProp(p) {
    return !styleProps.has(p);
  }
}).withConfig({
  displayName: "Link"
})(["font-style:italic;outline:none;:link{color:", ";}:visited{color:", ";}:hover{color:", ";}:focus{color:", ";background-color:", ";}", ";"], function (p) {
  return p.variant === 'dark' ? p.theme.colors.darkContrast : p.theme.colors.callToAction;
}, function (p) {
  return p.variant === 'dark' ? p.theme.colors.darkContrast : p.theme.colors.mediumContrast;
}, function (p) {
  return p.theme.colors.base;
}, function (p) {
  return p.theme.colors.callToAction;
}, function (p) {
  return p.theme.colors.lightCallToAction;
}, margin);
Link.propTypes = {
  to: PropTypes.string.isRequired,
  variant: PropTypes.oneOf(['standard', 'dark'])
};
export default Link;